export enum USER_TAGS {
  // CIRCLES
  RED_WHEEL = 'RED_WHEEL',
  GREEN_WHEEL = 'GREEN_WHEEL',
  BLUE_WHEEL = 'BLUE_WHEEL',

  // SQUARES
  RED_RECT = 'RED_RECT',
  GREEN_RECT = 'GREEN_RECT',
  BLUE_RECT = 'BLUE_RECT',

  // STARS
  RED_STAR = 'RED_STAR',
  GREEN_STAR = 'GREEN_STAR',
  BLUE_STAR = 'BLUE_STAR',

  // TRIANGLE
  RED_TRIANGLE = 'RED_TRIANGLE',
  GREEN_TRIANGLE = 'GREEN_TRIANGLE',
  BLUE_TRIANGLE = 'BLUE_TRIANGLE',

  // STREAM
  RED_STREAM = 'RED_STREAM',
  GREEN_STREAM = 'GREEN_STREAM',
  BLUE_STREAM = 'BLUE_STREAM',
}

export const USER_TAGS_ORDER: USER_TAGS[] = Object.values(USER_TAGS);

export interface UserTagViewModel {
  name: USER_TAGS;
  icon: string;
  color: string;
  label: string;
}

export const USER_TAG_META_MAP: Record<USER_TAGS, Omit<UserTagViewModel, 'name' | 'label'>> = {
  // CIRCLES
  [USER_TAGS.RED_WHEEL]: { icon: 'lens', color: 'red' },
  [USER_TAGS.GREEN_WHEEL]: { icon: 'lens', color: 'green' },
  [USER_TAGS.BLUE_WHEEL]: { icon: 'lens', color: 'blue' },

  // SQUARES
  [USER_TAGS.RED_RECT]: { icon: 'square', color: 'red' },
  [USER_TAGS.GREEN_RECT]: { icon: 'square', color: 'green' },
  [USER_TAGS.BLUE_RECT]: { icon: 'square', color: 'blue' },

  // STARS
  [USER_TAGS.RED_STAR]: { icon: 'star', color: 'red' },
  [USER_TAGS.GREEN_STAR]: { icon: 'star', color: 'green' },
  [USER_TAGS.BLUE_STAR]: { icon: 'star', color: 'blue' },

  // TRIANGLE
  [USER_TAGS.RED_TRIANGLE]: { icon: 'change_history', color: 'red' },
  [USER_TAGS.GREEN_TRIANGLE]: { icon: 'change_history', color: 'green' },
  [USER_TAGS.BLUE_TRIANGLE]: { icon: 'change_history', color: 'blue' },

  // STREAM
  [USER_TAGS.RED_STREAM]: { icon: 'stream', color: 'red' },
  [USER_TAGS.GREEN_STREAM]: { icon: 'stream', color: 'green' },
  [USER_TAGS.BLUE_STREAM]: { icon: 'stream', color: 'blue' },
};
